module.exports = __webpack_public_path__ + "static/media/helpAccount3.da5a87a3.png";